// taken from https://clearbit.com/docs#enrichment-api-company-api-attributes
// probably best to update periodically
export default [
/*{
    'displayName': 'Id',
    'name': 'id'
  },*/
  {
    'displayName': 'Name',
    'name': 'name'
  },
  {
    'displayName': 'Legal Name',
    'name': 'legalName'
  },
  {
    'displayName': 'Domain',
    'name': 'domain'
  },
  {
    'displayName': 'Domain Aliases',
    'name': 'domainAliases'
  },
  {
    'displayName': 'Phone Numbers',
    'name': 'site.phoneNumbers'
  },
  {
    'displayName': 'Email Addresses',
    'name': 'site.emailAddresses'
  },
  {
    'displayName': 'Sector',
    'name': 'category.sector'
  },
  {
    'displayName': 'Industry Group',
    'name': 'category.industryGroup'
  },
  {
    'displayName': 'Industry',
    'name': 'category.industry'
  },
  {
    'displayName': 'Sub Industry',
    'name': 'category.subIndustry'
  },
/*{
    'displayName': 'Sic Code',
    'name': 'category.sicCode'
  },
  {
    'displayName': 'Naics Code',
    'name': 'category.naicsCode'
  },*/
  {
    'displayName': 'Tags',
    'name': 'tags'
  },
  {
    'displayName': 'Description',
    'name': 'description'
  },
  {
    'displayName': 'Founded Year',
    'name': 'foundedYear'
  },
  {
    'displayName': 'Location',
    'name': 'location'
  },
  {
    'displayName': 'Time Zone',
    'name': 'timeZone'
  },
/*{
    'displayName': 'UTC Offset',
    'name': 'utcOffset'
  },*/
  {
    'displayName': 'Street Number',
    'name': 'geo.streetNumber'
  },
  {
    'displayName': 'Street Name',
    'name': 'geo.streetName'
  },
/*{
    'displayName': 'Sub Premise',
    'name': 'geo.subPremise'
  },*/
  {
    'displayName': 'City',
    'name': 'geo.city'
  },
  {
    'displayName': 'Postal Code',
    'name': 'geo.postalCode'
  },
  {
    'displayName': 'State',
    'name': 'geo.state'
  },
  {
    'displayName': 'State Code',
    'name': 'geo.stateCode'
  },
  {
    'displayName': 'Country',
    'name': 'geo.country'
  },
  {
    'displayName': 'Country Code',
    'name': 'geo.countryCode'
  },
/*{
    'displayName': 'Latitude',
    'name': 'geo.lat'
  },
  {
    'displayName': 'Longitude',
    'name': 'geo.lng'
  },*/
  {
    'displayName': 'Logo',
    'name': 'logo'
  },
  {
    'displayName': 'Facebook Handle',
    'name': 'facebook.handle'
  },
  {
    'displayName': 'LinkedIn Handle',
    'name': 'linkedin.handle'
  },
  {
    'displayName': 'Twitter Handle',
    'name': 'twitter.handle'
  },
  {
    'displayName': 'Twitter Id',
    'name': 'twitter.id'
  },
  {
    'displayName': 'Twitter Bio',
    'name': 'twitter.bio'
  },
  {
    'displayName': 'Twitter Number Followers',
    'name': 'twitter.followers'
  },
  {
    'displayName': 'Twitter Number Following',
    'name': 'twitter.following'
  },
  {
    'displayName': 'Twitter Listed Location',
    'name': 'twitter.location'
  },
  {
    'displayName': 'Twitter Listed Site',
    'name': 'twitter.site'
  },
  {
    'displayName': 'Twitter Avatar',
    'name': 'twitter.avatar'
  },
  {
    'displayName': 'Crunchbase Handle',
    'name': 'crunchbase.handle'
  },
/*{
    'displayName': 'Email Provider',
    'name': 'emailProvider'
  },*/
  {
    'displayName': 'Corporation Type',
    'name': 'type'
  },
  {
    'displayName': 'Stock Ticker Symbol',
    'name': 'ticker'
  },
/*{
    'displayName': 'US EIN',
    'name': 'identifiers.usEIN'
  },*/
  {
    'displayName': 'Phone',
    'name': 'phone'
  },
/*{
    'displayName': 'Indexed At',
    'name': 'indexedAt'
  },*/
  {
    'displayName': 'Alexa US Rank',
    'name': 'metrics.alexaUsRank'
  },
  {
    'displayName': 'Alexa Global Rank',
    'name': 'metrics.alexaGlobalRank'
  },
  {
    'displayName': 'Headcount',
    'name': 'metrics.employees'
  },
  {
    'displayName': 'Headcount Range',
    'name': 'metrics.employeesRange'
  },
  {
    'displayName': 'Market Cap',
    'name': 'metrics.marketCap'
  },
  {
    'displayName': 'Capital Raised',
    'name': 'metrics.raised'
  },
  {
    'displayName': 'Annual Revenue',
    'name': 'metrics.annualRevenue'
  },
  {
    'displayName': 'Estimated Annual Revenue',
    'name': 'metrics.estimatedAnnualRevenue'
  },
  {
    'displayName': 'Fiscal Year End',
    'name': 'metrics.fiscalYearEnd'
  },
  {
    'displayName': 'Tech',
    'name': 'tech'
  },
  {
    'displayName': 'Domain',
    'name': 'parent.domain'
  }
]


// WEBPACK FOOTER //
// ./src/scripts/constants/ClearbitProperties.js